import { useQuery } from '@tallink/more-react-hooks'
import qs from 'query-string'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getEnvBasedConfig } from '../../../config/config'
import { getFirstValidVoucherId } from '../../../selectors/selectors'
import s from './BookTrip.module.scss'

export default function BookTrip() {
  const { t } = useTranslation()
  const voucherId = useSelector(getFirstValidVoucherId)
  const locale = useQuery('locale')
  const country = useQuery('country')

  return (
    <a
      className={s['book-trip']}
      href={`${getEnvBasedConfig().bookUrl}?${qs.stringify({ voucherId, locale, country })}`}
    >
      {t('confirmation.summary.bookTrip')}
    </a>
  )
}
